export default __webpack_public_path__ + "static/media/title_pc@2x.835b54ec.png";